import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {FormGroup, AbstractControl, FormBuilder, Validators} from '@angular/forms';
import { SectorsComponent } from "../../sectors.component";

import { BaToastNotificationService } from '../../../../../../theme/services/baToastNotification'
import { UserAccountApi, SectorApi } from '../../../../../../theme/services/sdk';

import {SectorList} from '../list/list.component';

@Component({
  selector: 'sector-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  providers:[UserAccountApi,SectorApi,SectorList,BaToastNotificationService]
})
export class SectorForm{

  public form:FormGroup;
  public name:AbstractControl;
  public description:AbstractControl;
  public submitted:boolean = false;

  sector:Object;

  constructor(fb:FormBuilder, protected user:UserAccountApi, protected sectorService:SectorApi, private sectorList:SectorList, private route: ActivatedRoute, private router: Router, private toast:BaToastNotificationService,private data: SectorsComponent) {
    this.form = fb.group({
      'name': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      'description': ['', Validators.compose([Validators.required, Validators.minLength(4)])]
    });

    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];
    this.user.isAuthenticated()?false:this.router.navigate(['login']);
  }

  ngOnInit() {
    this.data.sector.subscribe(data=>this.sector=data);
  }

  public onSubmit(values:Object):void {
    this.submitted = true;
    if (this.form.valid) {
      let self = this;
      let se;

      if(this.sector['id']){
        se = this.sectorService.upsert({
          id: this.sector['id'],
          name: self.name['value'],
          description: self.description['value'],
        })
      }else{
        se = this.sectorService.create({
          name: self.name['value'],
          description: self.description['value'],
        })
      }

      se.subscribe(res => {
        let msg: string;
        this.data.refresh();
        this.form.reset();
        if(this.sector['id']){
          this.data.cancelSelected();
          msg = 'Record updated';
        }else{
          msg = 'New sector added';
        }
        this.toast.success({
          heading: 'Success',
          text: msg,
          stack: 3
        });

      }, err=>{
        this.toast.error({
          heading: err.name,
          text: err.message,
          stack: 3
        });
        console.log(err);
      });
    }
  }

  cancelSelected(){
    this.data.cancelSelected();
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/sectors/components/form/form.component.ts